const CONFIG = {
  ENVIRONMENT: import.meta.env.VITE_ENVIRONMENT,
  GLITCHTIP_DSN:
    import.meta.env.VITE_GLITCHTIP_DSN ??
    'https://0995b90d976b489e8a5e7ec6eb9baee9@glitchtip.dev.knowme.biz/2',
  HOST:
    import.meta.env.VITE_ENVIRONMENT === 'local'
      ? import.meta.env.VITE_HOST_URL_LOCAL
      : import.meta.env.VITE_HOST_URL,
  JSESSION: import.meta.env.VITE_SESSION_ID,
  LOGIN_ELIVION_REDIRECT_URL: import.meta.env.VITE_LOGIN_ELIVION_REDIRECT_URL,
  LOGIN_REDIRECT_URL: import.meta.env.VITE_KEYCLOAK_REDIRECT_URL,
  PERFORMANCE_SCAN: import.meta.env.VITE_PERFORMANCE_SCAN,
};

export const DEFAULT_LANGUAGE = 'en';
export default CONFIG;
